import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal } from 'seagull';
import { useOverlayContext } from 'seagull/components/OverlayContext/OverlayContext';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
const CancelRunConfirmation = (param)=>{
    let { texts, biNames, onDecision } = param;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: biNames.confirm
            },
            secondaryButton: {
                name: biNames.keep
            }
        },
        title: texts.cancelConfirmTitle(),
        textAlignCenter: false,
        content: texts.cancelConfirmBody(),
        primaryButtonLabel: texts.cancelConfirmPrimary(),
        primaryButtonIntent: "destructive",
        secondaryButtonLabel: texts.cancelConfirmKeep(),
        onPrimaryButtonClick: ()=>onDecision(true),
        onSecondaryButtonClick: ()=>onDecision(false)
    });
};
export function useCancelRun(param) {
    let { runId, texts, biNames, cancel } = param;
    const { showModal } = useOverlayContext();
    const { mutate } = useMutationState({
        mutationFn: cancel,
        toasts: {
            errorMessage: texts.cancelFailedToast()
        }
    });
    const confirmCancel = ()=>showModal({
            biName: biNames.confirm,
            closeOnClickOutside: false,
            closeOnEscapeKey: false,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(CancelRunConfirmation, {
                    texts: texts,
                    biNames: biNames,
                    onDecision: dismissModal
                });
            }
        });
    return {
        cancelRun: async ()=>{
            if (await confirmCancel()) mutate(runId);
        }
    };
}
